import messageOrder from './order.js'
export default {
    install(Vue, router) {
        const order = new messageOrder(Vue, router)
        Vue.prototype.$messageOrder = order
    }
}


// WEBPACK FOOTER //
// ./src/plugins/message/index.js